export default __webpack_public_path__ + "static/media/LouverLevel5.e9232aaa.svg";